module.exports = __webpack_public_path__ + "img/Jtrebol.1595a3ea.png";